import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MediationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mediation"}/>
}
